import { createFileRoute, notFound } from "@tanstack/react-router";

import { useProject, useProjectId } from "../../shell/project";
import { agentWorkspaceEnabled } from "../../workspaces/agents/availability";

import TeamPage from "../../workspaces/agents/beside/TeamPage";

export const Route = createFileRoute("/_console/p/$org/$project/loop/team")({
  beforeLoad: () => {
    if (!agentWorkspaceEnabled) throw notFound();
  },
  loader: ({ context, params, cause }) => {
    if (cause === "stay") return;
    const ready = import("../../workspaces/agents/prefetch").then(({ prefetchTeamPage }) => prefetchTeamPage(context.queryClient, params));
    if (import.meta.env.SSR) return ready;
    void ready;
  },
  component: TeamRoute,
});

/** The team as a page of its own: every agent, the ones that need someone first. */
function TeamRoute() {
  const projectId = useProjectId();
  const { address } = useProject();
  if (!address) return null;
  return <TeamPage projectId={projectId} address={address} />;
}
